<template>
  <v-container>
    <p class="text-center body-1" v-if="distributions.length == 0 && !loading">
      You don't have any courses listed on your classroom homepage,<br />
      <router-link :to="{ name: 'coursedelivery' }">
        add a homepage course.</router-link
      >
    </p>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Select</th>
            <th class="text-left">Course Name</th>
            <th class="text-left shortcol">Price</th>
            <th class="text-right longcol">Specials</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in distributions"
            :key="item._id"
            class="clickable"
            @click="selected(item)"
          >
            <td>
              <v-checkbox
                color="green"
                readonly=""
                class="ma-auto"
                :value="item._id == value"
                dense=""
                hide-details=""
              ></v-checkbox>
            </td>
            <td>{{ item.course ? item.course.name : "Unknown course" }}</td>
            <td>{{ item.logistics.price }}</td>
            <td class="text-right">
              <v-chip
                x-small=""
                class="ml-2"
                v-for="special in generateTags(item)"
                :key="special"
                :dark="special == 'Disabled'"
                :color="
                  special == 'Disabled'
                    ? 'red lighten-2 text--white'
                    : 'grey lighten-2'
                "
              >
                {{ special }}
              </v-chip>
            </td>
          </tr>
        </tbody>
        <tfoot v-if="distributions.length == 0 && !loading">
          No courses found
        </tfoot>
      </template>
    </v-simple-table>
  </v-container>
</template>
<style scoped>
.clickable:hover {
  cursor: pointer;
}
.selected {
  background-color: #bbdefb !important;
}
.selected:hover {
  background-color: #90caf9 !important;
}
</style>
<script>
import services from "@/services";
export default {
  props: ["value", "readonly"],
  data: () => ({
    loading: true,
    distributions: []
  }),
  methods: {
    selected(item) {
      if (this.readonly) {
        return;
      }
      this.$emit("input", `${item._id}`);
    },
    /**
     * @returns {Array}
     */
    async loadDistributions() {
      const results = await services.delivery.get({ type: "public" });
      const anonresults = results.filter(obj => {
        return obj && obj.properties
          ? obj.properties.allowAnonymousUsers
          : false;
      });
      return anonresults;
    },
    generateTags(delivery) {
      let cards = [];
      //Limit Copies
      if (delivery.logistics.limitCopies) {
        cards.push("Limit Users");
      }
      if (delivery.properties.allowAnonymousUsers) {
        cards.push("Account Not Required");
      }
      //Hidden
      if (delivery.properties.hidden) {
        cards.push("Hidden");
      }
      //Access Code
      if (delivery.properties.requireAccessCode) {
        cards.push("Access Code");
      }
      //Disabled
      if (delivery.properties.disabled) {
        cards.push("Disabled");
      }
      return cards;
    }
  },
  async mounted() {
    this.loading = true;
    const r = await this.loadDistributions();
    this.distributions = r
      .filter(obj => {
        return obj.properties ? !obj.properties.disabled : false;
      })
      .sort((a, b) => {
        return a.logistics.price - b.logistics.price;
      });
    this.loading = false;
  }
};
</script>

<style></style>
